// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the slides */
.general-slides-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    background-color: #dcca98; /* Softer background for better contrast */
  }
  
  /* Styling for individual slides */
  .slide {
    border: none;
    border-radius: 15px;
    padding: 30px;
    margin-bottom: 30px;
    display: fixed;
    background: #fff; /* Ensures content background stands out */
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15); /* Softer, more spread-out shadow for depth */
    transition: transform 0.2s ease, box-shadow 0.2s ease; /* Adds smooth hover effect */
  }
  
  .slide:hover {
    transform: translateY(-5px); /* Subtle lift on hover */
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.2); /* Enhanced shadow on hover */
  }
  
  /* Title text inside the slides */
  .slide h2 {
    text-align: center;
    font-size: 2em;
    color: #333; /* Darker color for better readability */
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  }
  
  /* Content inside the slide */
  .slide-content {
    background-color: rgba(255, 255, 255, 0.95); /* Slight opacity for a layered look */
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Light shadow for contrast */
  }
  
  /* Subtitle styling */
  .slide-content h3 {
    font-size: 1.5em;
    color: #444; /* Slightly softer for better readability */
    margin-bottom: 15px;
    border-bottom: 2px solid #ddd; /* Cleaner line for separation */
    padding-bottom: 5px;
    transition: border-color 0.2s ease;
  }
  
  .slide-content h3:hover {
    border-color: #bbb; /* Slight color change on hover for interactivity */
  }
  
  /* Paragraphs and list items inside the slide content */
  .slide-content p, .slide-content li {
    font-size: 1.15em;
    color: #555; /* Softer tone for better readability */
    line-height: 1.8; /* Increased for better readability */
    margin-bottom: 10px;
  }
  
  /* Custom gradients for each type of slide */
  .slide.title-slide {
    background: linear-gradient(135deg, #7b4397 0%, #dc2430 100%);
    color: #fff; /* Ensures text contrasts against gradient */
  }
  
  .slide.overview-slide {
    background: linear-gradient(135deg, #66cdaa 0%, #20b2aa 100%);
    color: #fff;
  }
  
  .slide.history-slide {
    background: linear-gradient(135deg, #f4a460 0%, #ffd700 100%);
    color: #fff;
  }
  
  .slide.features-slide {
    background: linear-gradient(135deg, #f08080 0%, #ff6347 100%);
    color: #fff;
  }
  
  .slide.community-slide {
    background: linear-gradient(135deg, #90ee90 0%, #32cd32 100%);
    color: #fff;
  }
  
  .slide.significance-slide {
    background: linear-gradient(135deg, #dda0dd 0%, #ba55d3 100%);
    color: #fff;
  }
  
  .slide.tourist-slide {
    background: linear-gradient(135deg, #8a2be2 0%, #4b0082 100%);
    color: #fff;
  }
  
  .slide.preservation-slide {
    background: linear-gradient(135deg, #87ceeb 0%, #1e90ff 100%);
    color: #fff;
  }
  
  .slide.conclusion-slide {
    background: linear-gradient(135deg, #ffa500 0%, #ff4500 100%);
    color: #fff;
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .slide {
      padding: 20px;
    }
  
    .slide h2 {
      font-size: 1.5em;
    }
  
    .slide-content h3 {
      font-size: 1.2em;
    }
  
    .slide-content p, .slide-content li {
      font-size: 1em;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/SlideGenerator/GeneralSlides.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB,EAAE,0CAA0C;EACvE;;EAEA,kCAAkC;EAClC;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB,EAAE,0CAA0C;IAC5D,0CAA0C,EAAE,6CAA6C;IACzF,qDAAqD,EAAE,6BAA6B;EACtF;;EAEA;IACE,2BAA2B,EAAE,yBAAyB;IACtD,0CAA0C,EAAE,6BAA6B;EAC3E;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW,EAAE,wCAAwC;IACrD,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C,EAAE,4BAA4B;EAC3E;;EAEA,6BAA6B;EAC7B;IACE,2CAA2C,EAAE,sCAAsC;IACnF,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C,EAAE,8BAA8B;EAC5E;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,WAAW,EAAE,2CAA2C;IACxD,mBAAmB;IACnB,6BAA6B,EAAE,gCAAgC;IAC/D,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE,kBAAkB,EAAE,mDAAmD;EACzE;;EAEA,uDAAuD;EACvD;IACE,iBAAiB;IACjB,WAAW,EAAE,uCAAuC;IACpD,gBAAgB,EAAE,qCAAqC;IACvD,mBAAmB;EACrB;;EAEA,4CAA4C;EAC5C;IACE,6DAA6D;IAC7D,WAAW,EAAE,4CAA4C;EAC3D;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA;IACE,6DAA6D;IAC7D,WAAW;EACb;;EAEA,sBAAsB;EACtB;IACE;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;IAChB;EACF","sourcesContent":["/* Container for the slides */\n.general-slides-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    background-color: #dcca98; /* Softer background for better contrast */\n  }\n  \n  /* Styling for individual slides */\n  .slide {\n    border: none;\n    border-radius: 15px;\n    padding: 30px;\n    margin-bottom: 30px;\n    display: fixed;\n    background: #fff; /* Ensures content background stands out */\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15); /* Softer, more spread-out shadow for depth */\n    transition: transform 0.2s ease, box-shadow 0.2s ease; /* Adds smooth hover effect */\n  }\n  \n  .slide:hover {\n    transform: translateY(-5px); /* Subtle lift on hover */\n    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.2); /* Enhanced shadow on hover */\n  }\n  \n  /* Title text inside the slides */\n  .slide h2 {\n    text-align: center;\n    font-size: 2em;\n    color: #333; /* Darker color for better readability */\n    margin-bottom: 20px;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n  }\n  \n  /* Content inside the slide */\n  .slide-content {\n    background-color: rgba(255, 255, 255, 0.95); /* Slight opacity for a layered look */\n    border-radius: 10px;\n    padding: 20px;\n    margin-bottom: 20px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Light shadow for contrast */\n  }\n  \n  /* Subtitle styling */\n  .slide-content h3 {\n    font-size: 1.5em;\n    color: #444; /* Slightly softer for better readability */\n    margin-bottom: 15px;\n    border-bottom: 2px solid #ddd; /* Cleaner line for separation */\n    padding-bottom: 5px;\n    transition: border-color 0.2s ease;\n  }\n  \n  .slide-content h3:hover {\n    border-color: #bbb; /* Slight color change on hover for interactivity */\n  }\n  \n  /* Paragraphs and list items inside the slide content */\n  .slide-content p, .slide-content li {\n    font-size: 1.15em;\n    color: #555; /* Softer tone for better readability */\n    line-height: 1.8; /* Increased for better readability */\n    margin-bottom: 10px;\n  }\n  \n  /* Custom gradients for each type of slide */\n  .slide.title-slide {\n    background: linear-gradient(135deg, #7b4397 0%, #dc2430 100%);\n    color: #fff; /* Ensures text contrasts against gradient */\n  }\n  \n  .slide.overview-slide {\n    background: linear-gradient(135deg, #66cdaa 0%, #20b2aa 100%);\n    color: #fff;\n  }\n  \n  .slide.history-slide {\n    background: linear-gradient(135deg, #f4a460 0%, #ffd700 100%);\n    color: #fff;\n  }\n  \n  .slide.features-slide {\n    background: linear-gradient(135deg, #f08080 0%, #ff6347 100%);\n    color: #fff;\n  }\n  \n  .slide.community-slide {\n    background: linear-gradient(135deg, #90ee90 0%, #32cd32 100%);\n    color: #fff;\n  }\n  \n  .slide.significance-slide {\n    background: linear-gradient(135deg, #dda0dd 0%, #ba55d3 100%);\n    color: #fff;\n  }\n  \n  .slide.tourist-slide {\n    background: linear-gradient(135deg, #8a2be2 0%, #4b0082 100%);\n    color: #fff;\n  }\n  \n  .slide.preservation-slide {\n    background: linear-gradient(135deg, #87ceeb 0%, #1e90ff 100%);\n    color: #fff;\n  }\n  \n  .slide.conclusion-slide {\n    background: linear-gradient(135deg, #ffa500 0%, #ff4500 100%);\n    color: #fff;\n  }\n  \n  /* Responsive design */\n  @media (max-width: 768px) {\n    .slide {\n      padding: 20px;\n    }\n  \n    .slide h2 {\n      font-size: 1.5em;\n    }\n  \n    .slide-content h3 {\n      font-size: 1.2em;\n    }\n  \n    .slide-content p, .slide-content li {\n      font-size: 1em;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
